<template>
	<div class="uploadStyle" :class="{'isData':isData}">
		<el-upload
			ref="uploadref"
			v-model:file-list="fileList"
			action="#"
			list-type="picture-card"
			:before-upload="beforeAvatarUpload"
			:on-preview="handlePictureCardPreview"
      :append-to-body="false"
			:before-remove="beforeRemove"
			:on-remove="handleRemove"
			:http-request="httpRequest"
			:limit="limit"
			:class="{ hide:hideUpload }"
		>
			<el-icon><Plus /></el-icon>
		</el-upload>
		<el-dialog v-model="dialogVisible">
			<img w-full :src="dialogImageUrl" alt="Preview Image" class="preview-img" />
		</el-dialog>
	</div>
	
</template>

<script>
import { getCurrentInstance, reactive, toRefs,ref,watch } from 'vue'
import { Plus } from '@element-plus/icons-vue'
	export default{
		name:"avatarUpload",
		props:{
			limit:{
				type:Number,
				default:1
			},
			fileType:{
				type:Array,
				default:function(){return []}
			},
			maxSize:{
				type:Number,
				default:10
			},
			imageUrl:{
				type:String,
				default:""
			},
			isData:{
				type:Boolean,
				default:false
			}
			// uploadref:{
			// 	type:String,
			// 	default:""
			// }
		},
		components: {Plus},
		setup(props,context){
			const { proxy } = getCurrentInstance();
			const uploadref=ref()
			console.log(uploadref)
			let data=reactive({
				fileList:[],
				hideUpload:false,
				dialogVisible:false,
				dialogImageUrl:"",
				commenUrl:proxy.commenUrl,
			});
			function beforeAvatarUpload(file){
				console.log(file)
				let isJPG = false;
				if(props.fileType&&props.fileType.length>0) {
					props.fileType.forEach((item) => {
						if(file.type == item) {
							isJPG = true;
						}
					})
				} else {
					isJPG = (file.type == 'image/jpeg' || file.type == 'image/jpg' || file.type == 'image/bmp' || file.type == 'image/png' || file.type == 'image/gif');
				}
				const isLt2M = file.size / 1024  < (props.maxSize*1024);
				if (!isJPG) {
					proxy.$message.error('上传图片格式有误')
					return false
				}
				if (!isLt2M) {
					proxy.$message.error('上传图片大小不能超过 '+ props.maxSize + 'M!')
					return false
				}
				return true
			}
			function handlePictureCardPreview(uploadFile){
				data.dialogVisible=true;
				data.dialogImageUrl=uploadFile.url
			}
			function beforeRemove(file,fileList){
				console.log(file)
				console.log(fileList)
			}
			function handleRemove(file,fileList) {
				console.log(file)
				console.log(fileList)
				if(file.status=="uploading"){
					uploadref.value.abort()
				}else{
					context.emit("delImageData");
					data.fileList=[];
				}
				data.hideUpload = data.fileList.length >= props.limit;
					
			}
			function httpRequest(params){
				console.log(params)
				data.hideUpload =true;
				let fm=new FormData();
				fm.append("file",params.file);
				proxy.$request({
					url:"SYS_UPLOADIMG",
					method: "post",
					data:fm,
					onUploadProgress: (progressEvent) =>{
						let complete = parseInt(((progressEvent.loaded / progressEvent.total) * 100));
						if(complete>90){
							complete=90
						}
						params.onProgress({ percent: complete });
					},
				}).then(res => {
					params.onProgress({ percent: 100 });
					if (res.data.code == "000") {
						const path=res.data.result.filesMap.file[0].path;
						setTimeout(()=>{
							context.emit("getImageData",path);
							data.fileList=[{name:"",url:data.commenUrl+path}]
							data.hideUpload = data.fileList.length >= props.limit;
						},1000);
					}
					fm.delete("file");
				}).catch( err => {
					fm.delete("file");
					params.onProgress({ percent: 100 });
					proxy.$message.error('上传失败')
					uploadref.value.handleRemove(params.file)
					console.log(err)
				})
			}
			watch(()=>props.imageUrl,(newValue)=>{
        console.log(props.imageUrl)
				if(newValue){
					data.fileList=[{name:"",url:data.commenUrl+newValue}];
				}else{
          data.fileList=[];
        }
        data.hideUpload = data.fileList.length >= props.limit;
			},{immediate:true})
			return {
				...toRefs(data),
				beforeAvatarUpload,
				handlePictureCardPreview,
				beforeRemove,
				handleRemove,
				httpRequest,
				uploadref,
			}
		}
	}

</script>

<style lang="less" rel="stylesheet" scoped>
.uploadStyle{
	:deep(.el-upload--picture-card,.avatar-uploader .el-upload){
    width: 146px;
    height: 146px;
    border-radius: 2px;
    background-color: #f2f4f7;
    border: solid 1px #e5e6eb;
  }
  :deep(.hide .el-upload--picture-card) {
		display: none;
  }
  .preview-img{
    width: 100%;
  }
}
.uploadStyle.isData{
	:deep(.el-upload--picture-card){
		width: 50px;
    	height: 40px;
	}
	:deep(.el-upload-list--picture-card .el-upload-list__item){
		width: 50px;
    	height: 40px;
		margin:0;
	}
	:deep(.el-upload-list__item.is-success .el-upload-list__item-status-label){
		display:none;
	}
	:deep(.el-upload-list--picture-card .el-upload-list__item-actions span+span){
		margin-left:0;
	}
}
</style>